import { Box, Button, styled, TextField } from "@mui/material";

export const CssButton = styled(Button)(() => ({
  borderRadius: "35px",
}));

export const CssBox = styled(Box)(() => ({
  boxShadow: "0 0 7px rgba(0,0,0,.1)",
  borderRadius: "7px",
  padding: "10px",
  borderLeft: "5px solid #46bda7"
}))

export const CssTextField = styled(TextField)({
  "& label.Mui-focused": {
    color: "#46bda7",
  },
  "& .MuiInput-underline:after": {
    borderBottomColor: "#46bda7",
  },
  
  "& .MuiOutlinedInput-root": {
    "& fieldset": {
      borderColor: "#838383",
      borderRadius: "35px",
    },
    "&:hover fieldset": {
      borderColor: "#46bda7",
    },
    "&.Mui-focused fieldset": {
      borderColor: "#46bda7",
      backgroundColor: "transparent",
      borderRadius: "35px"
    },
    "&.Mui-disabled fieldset": {
      backgroundColor: "transparent"
    },
  },
});